"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_keyby_1 = __importDefault(require("lodash.keyby"));
const uuid_1 = require("uuid");
const common_1 = require("@affinidi/common");
const _defaultConfig_1 = require("../_defaultConfig");
const SdkError_1 = __importDefault(require("../shared/SdkError"));
let fetch;
/* istanbul ignore next */
if (!fetch) {
    fetch = require('node-fetch');
}
const _registry_json_1 = __importDefault(require("../_registry.json"));
const _issuer_json_1 = __importDefault(require("../_issuer.json"));
const _verifier_json_1 = __importDefault(require("../_verifier.json"));
const common_2 = require("@affinidi/common");
let ApiService = class ApiService {
    constructor(registryUrl, issuerUrl, verifierUrl, options = {}) {
        this._issuerUrl = issuerUrl || _defaultConfig_1.STAGING_ISSUER_URL;
        this._registryUrl = registryUrl || _defaultConfig_1.STAGING_REGISTRY_URL;
        this._verifierUrl = verifierUrl || _defaultConfig_1.STAGING_VERIFIER_URL;
        this._accessApiKey = options.accessApiKey;
        const isApiKeyAValidUuid = options.apiKey && uuid_1.validate(options.apiKey);
        if (isApiKeyAValidUuid) {
            const apiKeyBuffer = common_1.KeysService.sha256(Buffer.from(options.apiKey));
            this._accessApiKey = apiKeyBuffer.toString('hex');
        }
        if (!this._accessApiKey) {
            const apiKeyBuffer = common_1.KeysService.sha256(Buffer.from('testApiKey'));
            this._accessApiKey = apiKeyBuffer.toString('hex');
        }
        this._specGroupByOperationId = {};
        this._parseSpecs();
    }
    _parseSpecs() {
        const specs = [_registry_json_1.default, _issuer_json_1.default, _verifier_json_1.default];
        for (const spec of specs) {
            const serviceName = spec.info.title.replace('affinity-', '');
            const map = this._parseSpec(spec);
            this._specGroupByOperationId[serviceName] = map;
        }
    }
    _parseSpec(rawSpec) {
        const spec = [];
        const basePath = rawSpec.servers[0].url;
        for (const operationPath in rawSpec.paths) {
            const operation = rawSpec.paths[operationPath];
            const path = `${basePath}${operationPath}`;
            for (const method in operation) {
                const { operationId } = operation[method];
                spec.push({
                    path,
                    method,
                    operationId,
                });
            }
        }
        return lodash_keyby_1.default(spec, 'operationId');
    }
    execute(serviceOperation, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!options.url) {
                const [serviceName, operationId] = serviceOperation.split('.');
                const operation = this._specGroupByOperationId[serviceName][operationId];
                const { method, path } = operation;
                let networkUrl;
                switch (serviceName) {
                    case 'registry':
                        networkUrl = this._registryUrl;
                        break;
                    case 'issuer':
                        networkUrl = this._issuerUrl;
                        break;
                    case 'verifier':
                        networkUrl = this._verifierUrl;
                        break;
                }
                options.url = `${networkUrl}${path}`;
                options.method = method;
            }
            options.headers = options.headers || {};
            options.headers['Accept'] = 'application/json';
            options.headers['Content-Type'] = 'application/json';
            options.headers['Api-Key'] = this._accessApiKey;
            if (options.params) {
                let { params: body } = options;
                body = JSON.stringify(body, null, 2);
                options.body = body;
            }
            const { url } = options;
            delete options.params;
            delete options.url;
            const response = yield fetch(url, options);
            const { status } = response;
            let jsonResponse;
            if (status.toString().startsWith('2')) {
                jsonResponse = yield response.json();
            }
            else {
                const error = yield response.json();
                const { code, message, context } = error;
                throw new SdkError_1.default({ code, message }, context, Object.assign({}, error, { httpStatusCode: status }));
            }
            return { body: jsonResponse, status };
        });
    }
};
ApiService = __decorate([
    common_2.profile()
], ApiService);
exports.default = ApiService;
//# sourceMappingURL=ApiService.js.map